export default "__VITE_ASSET__B1jA1ThR__"